module.exports = __webpack_public_path__ + "static/img/un.19f1d0df.svg";